import { appSettings } from "config";

/**
 * Helper function to get the prefixed index name for an Algolia index.
 * @param indexName - The base name of the Algolia index to search.
 * @returns the prefixed index name based on the current environment. e.g: 'dev_Businesses'
 */
export const getPrefixedIndexName = (indexName: string) => {
  return `${appSettings.tgtEnvName}_${indexName}`;
}